import { Expose, plainToInstance } from "class-transformer";
import {
  IsBoolean,
  IsDate,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsPositive,
  IsString,
} from "class-validator";
import { ContractorProfile } from "../contractor-profile";

export class Match {
  public static from(match: Match) {
    return plainToInstance(Match, match, {
      excludeExtraneousValues: true,
    });
  }

  @Expose()
  @IsString()
  @IsNotEmpty()
  buildProjectId!: string;

  @Expose()
  @IsDate()
  createdTs!: Date;

  @Expose()
  @IsDate()
  updatedTs!: Date;

  @Expose()
  @IsNumber()
  rank!: number;

  @Expose()
  @IsString()
  @IsNotEmpty()
  contractorId!: string;

  @Expose()
  @IsOptional()
  @IsNumber()
  @IsPositive()
  totalContractValue?: number;

  @Expose()
  @IsOptional()
  contractor?: ContractorProfile;

  @Expose()
  @IsOptional()
  @IsDate()
  matchedTs?: Date | null;

  @Expose()
  @IsOptional()
  @IsBoolean()
  archived?: boolean;

  @Expose()
  @IsOptional()
  @IsDate()
  archivedTs?: Date | null;
}
